import { useEffect, useState } from "react"

import { useLazyGetStatusQuery } from "store/api/widgetsApi"

import { HalfDoughnutSummaryWidget } from "components/widgets/HalfDoughnutSummaryWidget"

const CHART_CONFIG = [
  { key: "installed" as const, label: "Installed", color: "#86efac" },
  { key: "missing" as const, label: "Missing", color: "#fcd34d" },
  { key: "transferring" as const, label: "Transferring", color: "#2563eb" },
  { key: "inventory" as const, label: "In Inventory", color: "#f5d0ec" },
  { key: "preinstalled" as const, label: "Pre-installed", color: "#14b8a6" },
  { key: "warranty" as const, label: "Warranty", color: "#59afc6" },
] as const

interface Props {
  updateIndex: number
}

export const WidgetStatus = ({ updateIndex }: Props) => {
  const [triggerGetStatus, { isFetching }] = useLazyGetStatusQuery()
  const [widgetData, setWidgetData] = useState({
    installed: 0,
    missing: 0,
    transferring: 0,
    inventory: 0,
    preinstalled: 0,
    warranty: 0,
  })

  useEffect(() => {
    const fetchData = async () => {
      const res = await triggerGetStatus()
      if (res?.data?.data) {
        const d = res.data.data
        setWidgetData({
          installed: d.installed ?? 0,
          missing: d.missing ?? 0,
          transferring: d.transferring ?? 0,
          inventory: d.inventory ?? 0,
          preinstalled: d.preinstalled ?? 0,
          warranty: d.warranty ?? 0,
        })
      }
    }

    fetchData()
  }, [updateIndex, triggerGetStatus])

  const items = CHART_CONFIG.map(({ key, label, color }) => ({
    label,
    color,
    value: widgetData[key] ?? 0,
  }))

  return (
    <HalfDoughnutSummaryWidget
      title="Thermostats Statuses"
      mainLabel="Thermostats"
      items={items}
      chartOptions={{ cutout: "65%" }}
      legendCenteredWrap
      isFetching={isFetching}
    />
  )
}
